import { render, staticRenderFns } from "./ContentEditor.vue?vue&type=template&id=00d1d2d3&scoped=true"
import script from "./ContentEditor.vue?vue&type=script&lang=js"
export * from "./ContentEditor.vue?vue&type=script&lang=js"
import style0 from "./ContentEditor.vue?vue&type=style&index=0&id=00d1d2d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1d2d3",
  null
  
)

export default component.exports